import React, { useState, useEffect } from "react";
import "./CreateQuestionForm.css";
import Select from "react-select";

function CreateQuestionForm({ defaultQuizType, onClose, onSave }) {
  const [formData, setFormData] = useState({
    questionText: "",
    score: "positive",
    enabled: true,
    questionClass: "Empathic Response",
    quiz_type: defaultQuizType,
    visibleToRoles: [],
    recommendations: [],
  });
  const [recommendationOptions, setRecommendationOptions] = useState([]);

  const questionClasses = ["Empathic Response", "Cognitive", "Affective"];
  const allRoles = [
    { value: "Admin", label: "Admin" },
    { value: "Software Developer", label: "Software Developer" },
    { value: "Tester", label: "Tester" },
    { value: "Software Architect", label: "Software Architect" },
    { value: "Product Manager", label: "Product Manager" },
    { value: "Business Analyst", label: "Business Analyst" },
    { value: "Product Owner", label: "Product Owner" },
    { value: "UI/UX", label: "UI/UX" },
    { value: "DevOps Engineer", label: "DevOps Engineer" },
    { value: "Practitioner", label: "Practitioner" },
    { value: "Guest", label: "Guest" },
  ];

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/recommendations`,
      {
        method: "GET",
        credentials: "include",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setRecommendationOptions(
          data.map((rec) => ({
            value: rec.id,
            label: `${rec.id} - ${rec.text}`,
          }))
        );
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <h3>Create New Question</h3>
        <form onSubmit={handleSubmit}>
          <label>
            Question Text:
            <textarea
              name="questionText"
              value={formData.questionText}
              onChange={handleChange}
              required
              rows={4}
            />
          </label>
          <div className="form-row">
            <label>
              Class:
              <select
                required
                name="questionClass"
                value={formData.questionClass}
                onChange={handleChange}
              >
                {questionClasses.map((c) => (
                  <option key={c}>{c}</option>
                ))}
              </select>
            </label>
            <label>
              Score:
              <select
                required
                name="score"
                value={formData.score}
                onChange={handleChange}
              >
                <option value="positive">Positive</option>
                <option value="negative">Negative</option>
              </select>
            </label>
            <label>
              Quiz Type:
              <select
                required
                name="quiz_type"
                value={formData.quiz_type}
                onChange={handleChange}
              >
                <option value="user">User</option>
                <option value="prac">Prac</option>
              </select>
            </label>
          </div>
          <label>
            <input
              type="checkbox"
              checked={formData.enabled}
              onChange={(e) =>
                setFormData({ ...formData, enabled: e.target.checked })
              }
            />
            Enabled
          </label>
          <label>
            Visible To Roles:
            <Select
              isMulti
              required
              closeMenuOnSelect={false}
              options={allRoles}
              value={formData.visibleToRoles.map((role) => ({
                value: role,
                label: role,
              }))}
              onChange={(selectedOptions) => {
                setFormData((prev) => ({
                  ...prev,
                  visibleToRoles: selectedOptions.map((option) => option.value),
                }));
              }}
            />
          </label>
          <label>
            Recommendations: <span style={{ color: "red" }}>*</span>
            <Select
              isMulti
              required
              closeMenuOnSelect={false}
              options={recommendationOptions}
              value={recommendationOptions.filter((option) =>
                formData.recommendations?.includes(option.value)
              )}
              onChange={(selectedOptions) => {
                setFormData((prev) => ({
                  ...prev,
                  recommendations: selectedOptions.map(
                    (option) => option.value
                  ),
                }));
              }}
            />
          </label>
          <div className="modal-buttons">
            <button className="blue-button" type="submit">
              Create
            </button>
            <button className="red-button" type="button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateQuestionForm;
